import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { normalizeContentSearch, type ContentSearch } from '@/lib/route-search';
import { PostsList } from '@/components/content/PostsList';
import { PortfolioList } from '@/components/content/PortfolioList';
import { ResumePage } from '@/components/content/ResumePage';

export const Route = createFileRoute('/content')({
  validateSearch: normalizeContentSearch,
  component: ContentPage,
});

// 탭 UI는 사이드바로 승격됨 — 이 라우트는 tab 파라미터에 따른 배선만 담당
function ContentPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/content' });

  function updateSearch(patch: Partial<ContentSearch>, replace = true) {
    void navigate({
      search: previous => normalizeContentSearch({ ...previous, ...patch }),
      replace,
    });
  }

  if (search.tab === 'portfolio') return <PortfolioList />;
  if (search.tab === 'resume') {
    return <ResumePage days={search.days} onDaysChange={days => updateSearch({ days })} />;
  }
  return (
    <PostsList
      state={{ status: search.status, q: search.q }}
      onStateChange={patch => updateSearch(patch)}
    />
  );
}
